import {nativeAppAdapter} from "app/employee/nativeApp/FSAcademyAndroidAdapter";
import {query} from "app/gql/client";
import {UpdateFcmTokenDocument} from "app/gql/graphqlSchema";
import {useSetTimeout} from "@fluentui/react-hooks";
import {useEffect, useRef} from "react";

const RETRY_INTERVAL = 30000;
const MAX_COUNT = 3;

export const useUpdateFcmToken = () => {
  const {setTimeout} = useSetTimeout();
  const countdownRef = useRef(MAX_COUNT);
  useEffect(() => {
    if (!nativeAppAdapter.isRunningInAndroidApp()) {
      return;
    }
    const updateToken = async () => {
      if (countdownRef.current > 0) {
        countdownRef.current--;

        if (nativeAppAdapter.isNotificationPermissionGranted()) {
          const token = await nativeAppAdapter.requestNotificationToken();
          await query(UpdateFcmTokenDocument, {input: {token}});
        } else {
          setTimeout(updateToken, RETRY_INTERVAL);
        }
      }
    };
    updateToken();
  }, [setTimeout]);
};
